import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export const SpdrRelationUpdateModeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[{ Status: "Active" }, { Status: "New" }, { Status: "Expired" }, { Status: "Manual" }]}
    searchBox={() => null}
    {...props}
  />
);
